// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"d74643e2","1444":"06adefca","7267":"d74643e2","8021":"cce2637a","8693":"d74643e2"}[chunkId] + ".chunk.css";
};